import {Button, Form, Input, Spin} from "antd";
import classes from './Login.module.css'
import {useState} from "react";
import {useDispatch} from "react-redux";
import {SET_IS_LOGGED_IN, SET_USER_NAME} from "../../store";
import {useNavigate} from "react-router";
import {FOUR_SPORT_LIVE_URL} from "../../constants";


interface IUserDetailsResponse {
    error: boolean
    message: string
    username?: string
    caruzPermission?: boolean
}

export default function Login() {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    function login(values: any) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(values)
        };
        setIsLoading(true)
        fetch(`${FOUR_SPORT_LIVE_URL}/api-token-auth/`, {...requestOptions, credentials: "omit"})
            .then(response => response.json())
            .then((response) => {
                    setIsLoading(false)
                    if(response.token == null) {
                        alert("Unable to log in with provided credentials.")
                        return
                    }
                    getUserDetails(response.token)
                },
                (error) => {
                    setIsLoading(false)
                    alert(error)
                }
            )
    }


    function getUserDetails(token: string) {
        setIsLoading(true)
        fetch(`${FOUR_SPORT_LIVE_URL}/apis/getUserDetails/`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Token ' + token
            },
        }).then(response => response.json()).then((userDetails: IUserDetailsResponse) => {
                setIsLoading(false)
                if(userDetails.error) {
                    alert(userDetails.message)
                    return
                }
                if(!userDetails.caruzPermission) {
                    alert('this user dont have the caruz permission')
                    return;
                }
                loginDidSuccess(token, userDetails.username || '')
            },
            (error) => {
                setIsLoading(false)
                alert(error)
            }
        )
    }

    function loginDidSuccess(token: string, username: string) {
        localStorage.setItem('caruzToken', token);
        localStorage.setItem('caruzUsername', username);
        setIsLoading(false)
        dispatch({
            type: SET_IS_LOGGED_IN,
            payload: {
                isLoggedIn: true
            }
        })

        dispatch({
            type: SET_USER_NAME,
            payload: {
                username: username
            }
        })
        navigate('/events')
    }

    return(
        <Spin spinning={isLoading}>
            <Form className={classes['login-form']}
                  name="basic"
                  layout="vertical"
                  onFinish={login}
                  initialValues={{
                      remember: true,
                  }}
            >
                <Form.Item
                    label="Username"
                    name="username"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your username!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    )
}